import { combineReducers, compose, createSelector } from '@reduxjs/toolkit';

import slice from './products.slice';
import productsAdapter from './products.adapter';

/** Represents the slice as it exists in the final store's reducer */
const combined = combineReducers({ [slice.name]: slice.reducer });
type GlobalState = ReturnType<typeof combined>;

/** Get the local state for the current domain */
const localState = (state: GlobalState) => state[slice.name];
type LocalState = ReturnType<typeof localState>;

const defaultSelectors = productsAdapter.getSelectors();

export const selectAppliedProductFilter = (state: LocalState) => state.appliedFilter;

export const selectAllProductIdsBySlug = createSelector(
  [defaultSelectors.selectAll],
  (allProducts) =>
    allProducts.reduce((acc: Record<string, number>, product) => {
      acc[product.slug] = product.id;
      return acc;
    }, {})
);

export const selectProductNode = (state: LocalState, id: number, uid: string) =>
  state.entities[id]?.nodes.find((n) => n.uid === uid);

export default {
  ...productsAdapter.getSelectors(localState),
  bySlug: compose(selectAllProductIdsBySlug, localState),
  appliedFilter: compose(selectAppliedProductFilter, localState),
  findNode: (state: GlobalState, id: number, uid: string) =>
    selectProductNode(localState(state), id, uid),
};
